module.exports = __webpack_public_path__ + "static/media/grid.9cd5e49c.svg";